import React, {type ReactElement} from 'react';
import styles from './ai-chat-nav.module.scss';
import {AiChatAccountStatusBar} from '@/components/ai-chat-window/components/ai-chat-account-status-bar/ai-chat-account-status-bar';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {useStickyNav} from '@Hooks/useStickyNav';

export interface AiChatNavProps {
  className?: string;
}

export function AiChatNav({className = ''}: AiChatNavProps): ReactElement {
  const {state} = useAiChat();
  const {isSticky, navRef} = useStickyNav(56);

  const getDesktopAccountStatusBar = (): ReactElement | null => {
    if (state.isSmall) {
      return null;
    }

    return (
      <div className={styles.desktopAccountStatusBar}>
        <AiChatAccountStatusBar />
      </div>
    );
  };

  const showStickyNavInitially = (): boolean => {
    return state.currentChatId === undefined && !state.isQuickTipsView;
  };

  return (
    <div ref={navRef} className={`${styles.aiChatNav} ${showStickyNavInitially() ? styles.initiallySticky : ''} ${isSticky ? styles.sticky : ''} ${className}`}>
      {getDesktopAccountStatusBar()}
    </div>
  );
}

export default AiChatNav;
